import webTechImage from "../../../Assets/Images/Technology/image-Container.svg";
import mobile from "../../../Assets/Images/Technology/mobile.svg";
import cloud from "../../../Assets/Images/Technology/Cloud.png";
import database from "../../../Assets/Images/Technology/Database.png";
import uiUx from "../../../Assets/Images/Technology/UI-UX.png";
import "./Main.css";
import { Link } from "react-router-dom";

function Main() {
  return (
    <div className="tech-container">
      <div className="cards-grid">
        {/* Web Technology Card */}
        <Link to="/technologies/web">
          <div className="tech-card card-bg web-tech-card">
            <div className="card-content">
              <div className="icon-wrapper">
                <img
                  src={webTechImage}
                  alt="Web Technology"
                  className="tech-image"
                />
              </div>
            </div>
            <div className="text-sections">
              <h3 className="card-title">Web Technology</h3>
              <p className="card-tools">
                Tools: JS, React, HTML, Blazor, CSS, Microsoft Net...
              </p>
            </div>
          </div>
        </Link>

        {/* Mobile Technology Card */}
        <Link to="/technologies/mobile">
          <div className="tech-card card-bg">
            <div className="card-content">
              <div className="icon-wrapper">
                <img
                  src={mobile}
                  alt="Mobile Technology"
                  className="tech-image"
                />
              </div>
            </div>
            <div className="text-sections">
              <h3 className="card-title">Mobile Technology</h3>
              <p className="card-tools">
                Tools: Java, Flutter, Objective-c, React, Swift...
              </p>
            </div>
          </div>
        </Link>

        {/* UX/UI Design Card */}
        <Link to="/technologies/ui-ux">
          <div className="tech-card card-bg">
            <div className="card-content">
              <div className="icon-wrapper">
                <img src={uiUx} alt="UX/UI Design" className="tech-image" />
              </div>
            </div>
            <div className="text-sections">
              <h3 className="card-title">UX&UI Design</h3>
              <p className="card-tools">
                Tools: Figma, Framer, Illustrator, Photoshop...
              </p>
            </div>
          </div>
        </Link>

        {/* Database Card */}
        <Link to="/technologies/database">
          <div className="tech-card card-bg">
            <div className="card-content">
              <div className="icon-wrapper">
                <img
                  src={database}
                  alt="Database"
                  className="tech-image database-img"
                />
              </div>
            </div>
            <div className="text-sections">
              <h3 className="card-title">Database</h3>
              <p className="card-tools">
                Tools: My SQL, SQL Lite, Redis, MS SQL...
              </p>
            </div>
          </div>
        </Link>

        {/* Cloud Card */}
        <Link to="/technologies/cloud">
          <div className="tech-card card-bg">
            <div className="card-content">
              <div className="icon-wrapper">
                <img src={cloud} alt="Cloud" className="tech-image" />
              </div>
            </div>
            <div className="text-sections">
              <h3 className="card-title">Cloud</h3>
              <p className="card-tools">Tools: AWS, GCP, Firebase, Vercel...</p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Main;
